import { BillingDenialDto, BillingDenialResolveAction } from 'store/types'

export const DENIAL_STATUS_LABELS: Record<BillingDenialDto['status'], string> = {
  PENDING: 'Pending',
  IN_PROCESS: 'In Process',
  RESOLVED: 'Resolved',
}

export const DENIAL_RESOLUTION_LABELS: Record<NonNullable<BillingDenialDto['resolution']>, string> = {
  WRITE_OFF: 'Written off',
  PATIENT: 'Pushed to patient',
  POSTED: 'Posted',
  CLOSED: 'Closed, nothing left open',
  SUPERSEDED: 'Denied again',
  REBILLED: 'Rebilled to another payer',
}

// A rebilled denial names the payer the claim went to.
export const denialResolutionLabel = (
  resolution: NonNullable<BillingDenialDto['resolution']>,
  rebilledPayerName?: string | null,
): string =>
  resolution === 'REBILLED' && rebilledPayerName ? `Rebilled to ${rebilledPayerName}` : DENIAL_RESOLUTION_LABELS[resolution]

export const DENIAL_ACTION_LABELS: Record<BillingDenialDto['history'][number]['action'], string> = {
  RECORDED: 'Recorded',
  RESUBMITTED: 'Claim resubmitted',
  WRITTEN_OFF: 'Written off',
  PUSHED_TO_PATIENT: 'Pushed to patient',
  POSTED: 'Resolved by a posted payment',
  CLOSED: 'Closed',
  ASSIGNED: 'Owner changed',
  APPEALED: 'Appealed',
  MOVED_TO_IN_PROCESS: 'Moved to In Process',
  SUPERSEDED: 'Denied again',
  REBILLED: 'Rebilled to another payer',
  REOPENED: 'Reopened',
}

// Status changes that post nothing and take an optional note.
export const DENIAL_NOTE_ACTIONS = {
  APPEAL: {
    title: 'Appeal',
    done: 'Appealed',
    description: 'Marks the denials as appealed and moves them to In Process. Nothing posts until the payer answers.',
    placeholder: 'Appeal reference, what was sent…',
  },
  IN_PROCESS: {
    title: 'Move to In Process',
    done: 'Moved to In Process',
    description: 'Moves the denials to In Process while they are worked. Nothing posts.',
    placeholder: 'What is being done…',
  },
  REOPEN: {
    title: 'Reopen',
    done: 'Reopened',
    description:
      'Puts the denials back to Pending to be worked again. Nothing posts. '
      + 'A denial whose resolving payment is still posted reopens when that payment is reversed.',
    placeholder: 'Why it is reopened…',
  },
} as const

export type DenialNoteAction = keyof typeof DENIAL_NOTE_ACTIONS

export const DENIAL_RESOLVE_ACTION_LABELS: Record<BillingDenialResolveAction, string> = {
  WRITE_OFF: 'Write Off',
  PATIENT: 'Push to Patient',
}

export const OPEN_DENIAL_STATUSES: BillingDenialDto['status'][] = ['PENDING', 'IN_PROCESS']

export const DENIAL_WORKLIST_TABS: { status: BillingDenialDto['status']; label: string }[] = [
  { status: 'PENDING', label: 'Pending' },
  { status: 'IN_PROCESS', label: 'In Process' },
  { status: 'RESOLVED', label: 'Resolved' },
]

// The worklist key for lines recorded without a reason code.
export const DENIAL_NO_REASON_CODE = 'NONE'

// The worklist owner filter for denials nobody is assigned to.
export const DENIAL_UNASSIGNED = 'NONE'
